module.exports = __webpack_public_path__ + "media/images/home/application_message-2c3b959ad3732f63a0904049b2a80d44.svg";